export default {
  false: "💢&nbsp;no",
  true: "&nbsp;✔&nbsp;&nbsp;yes",
}
